import { EncounterDataMock, Included } from '@type/encounter.type'
import { ModalHeader } from '@ui'
import { Box, Layer, Text } from 'grommet'
import moment from 'moment'

type Props = {
  defaultData?: EncounterDataMock
  included?: Included[]
  onClose: () => void
}

export default function EncounterDetails({ defaultData, included = [], onClose }: Props) {
  const provider = included.find(
    ({ type, id }) => type === 'staff' && id === defaultData?.relationships.appointed_staff.data?.id
  )

  const details = [
    { label: 'Encounter ID', value: defaultData?.id || '-' },
    {
      label: 'Date',
      value: defaultData?.attributes.created_at ? moment(defaultData.attributes.created_at).format('DD/MM/YYYY') : '-'
    },
    {
      label: 'Provider',
      value: [provider?.attributes.first_name, provider?.attributes.last_name].filter(Boolean).join(' ') || '-'
    },
    { label: 'Visit type', value: defaultData?.attributes.encounter_type || '-' },
    { label: 'Status', value: defaultData?.meta.status || '-' },
    { label: 'Purpose', value: defaultData?.attributes.purpose || '-' }
  ]

  return (
    <Layer margin={{ vertical: '4px' }} modal onClickOutside={onClose} onEsc={onClose} position="right" style={{}}>
      <Box fill style={{ height: '100vh', width: 'min(500px, calc(100vw - 1.5rem))' }}>
        <ModalHeader onClose={onClose} title="Encounter Details" />
        <Box overflow={'auto'} pad={'medium'}>
          <Box gap="medium" pad="medium" width="480px">
            {details.map(item => (
              <Box direction="row" justify="between" key={item.label}>
                <Text color="#7A7A7A" size="14px">
                  {item.label}
                </Text>
                <Text className="capitalize" color="#111827" size="14px" textAlign="end">
                  {item.value}
                </Text>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Layer>
  )
}
